module.exports = __webpack_public_path__ + "89ce07f28c9963656f83f818c62fe095.png";


//////////////////
// WEBPACK FOOTER
// ./lib/app/resources/img/logo.png
// module id = 1826
// module chunks = 0